module.exports = __webpack_public_path__ + "static/media/Storm Spirit.5336f736.png";